export function LoadMore({
  nextCursor,
  loading,
  onLoadMore,
}: {
  nextCursor: string | null;
  loading: boolean;
  onLoadMore: () => void;
}) {
  if (!nextCursor) return null;
  return (
    <div className="row" style={{ justifyContent: "center", marginTop: "var(--space-3)" }}>
      <button className="btn" onClick={onLoadMore} disabled={loading}>
        {loading ? "Loading…" : "Load more"}
      </button>
    </div>
  );
}
